module.exports = __webpack_public_path__ + "img/三门峡市-c.2be004fa.png";